import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import { constants } from '../../../constants';
import { IPayment } from '../../../models/guest-oexpenses';
import {ObjectManagerUtils} from '../../../utils/object-manager.utils';
import {PaymentType} from '../../../models/guest-oexpenses-payment-type';
import {
  ICreateUpdateOnboardPaymentGrantee,
  ICreateUpdateOnboardPaymentPayload,
  ICreateUpdateOnboardPaymentAccount,
  ICreateUpdateOnboardPaymentCreditCard
} from '../../../models/action-payloads/create-update-onboard-payment-payload';
import {OexpensesCreditCardInterface, OexpensesStrategyInterface} from '../../../shared/interfaces';

@Injectable()
export class OExpensesUtils {
	constructor(
    private readonly objectManagerUtils: ObjectManagerUtils,
    private store?: Store<fromRoot.AppState>,
  ) {}

	createUpdateOnboardPaymentRequestPayload(
		guestPaymentList: IPayment[],
		additionalGrantees?: ICreateUpdateOnboardPaymentGrantee[]
	): ICreateUpdateOnboardPaymentPayload {
    let paymentType = '';
    let paymentResult: OexpensesStrategyInterface;
    let paymentAccount: ICreateUpdateOnboardPaymentAccount;
    let creditCard: ICreateUpdateOnboardPaymentCreditCard | any= {};
    const paymentAccounts: ICreateUpdateOnboardPaymentAccount[] = [];

		for (const guestPayment of guestPaymentList) {
			switch (guestPayment.paymentType) {
				case 3:
          paymentResult = this.thirdPaymentTypeProcess(guestPayment);
          paymentType = paymentResult.paymentType;
          creditCard = paymentResult.creditCard;
					break;

				case 2:
					paymentType = constants.PAYMENT_TYPE.CASH;
					break;

				default:
					paymentType = constants.PAYMENT_TYPE.NO_CHARGING_PRIVILEGES;
					break;
			}

			paymentAccount = {
				guestReservationId: {
					bookingId: Number(guestPayment.guest.bookingId),
					guestId: Number(guestPayment.guest.guestId)
				},
				grantees: [
					{
						guestReservationId: {
							bookingId: Number(guestPayment.guest.bookingId),
							guestId: Number(guestPayment.guest.guestId)
						}
					}
				],
				account: {
					paymentTypeCode: paymentType
				}
			};

			if (additionalGrantees) {
				paymentAccount.grantees.push(...additionalGrantees);
			}

			if (guestPayment.accountId) {
				paymentAccount.account.accountId = Number(guestPayment.accountId);
			}

			if (guestPayment.paymentType === PaymentType.CreditCard) {
				paymentAccount.account.card = {
					...creditCard,
					expirationYear: this.normalizeCcYear(creditCard.expirationYear)
				};		
			}

			paymentAccounts.push(paymentAccount);
		}

		return {
			paymentAccounts: paymentAccounts
		} as ICreateUpdateOnboardPaymentPayload;
	}

  private choosePaymentType(guestPayment: IPayment) {
    let paymentType = '';
    if (guestPayment?.cc?.cardType) {
      paymentType = guestPayment.cc.cardType;
    } else if (guestPayment?.cc?.cardTypeCode) {
      paymentType = guestPayment.cc.cardTypeCode;
    }
    return paymentType;
  }

  private thirdPaymentTypeProcess(guestPayment: IPayment): OexpensesStrategyInterface {
    const paymentType = this.choosePaymentType(guestPayment);
    const creditCard: OexpensesCreditCardInterface = {
      currencyConversion: {
        eligibilityFlag: this.objectManagerUtils.ternaryValidation(guestPayment?.cc?.nonUSCardFlag, guestPayment?.cc?.nonUSCardFlag, false),
        conversionAffirmation: this.objectManagerUtils.ternaryValidation(guestPayment?.cc?.conversionAffirmationFlag, guestPayment?.cc?.conversionAffirmationFlag, false)
      },
      partialNumber: this.objectManagerUtils.ternaryValidation(
        guestPayment?.cc && guestPayment.cc.partialNumber.length > 4,
        guestPayment?.cc?.partialNumber.slice(-4),
        guestPayment?.cc?.partialNumber
      ),
      holderName: guestPayment?.cc?.holderName || '',
      expirationYear: guestPayment?.cc?.expirationYear || 1900,
      expirationMonth: Number(guestPayment?.cc?.expirationMonth),
      tokenText: this.objectManagerUtils.ternaryValidation(guestPayment?.cc?.tokenText, guestPayment?.cc?.tokenText, '')
    };
    return { paymentType, creditCard };
  }

  private normalizeCcYear(date: string | number) {
    const stringDate = date.toString();
    const yearPrefix = '20';
    const fullYear = stringDate.length === 2 ? `${yearPrefix}${stringDate}` : stringDate;
    return parseInt(fullYear, 10);
  }
}
